import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import CheckUpdates from 'components/checkUpdates';
import LoginScreenCarousel from 'components/LoginScreenCarousel/login-screen-carousel';
import TermosDeUso from './termos-de-uso/TermosDeUso';
import CheckboxLogin from 'components/CheckboxLogin';
import LgpdLogin from '../../components/Login/lgpd/lgpd';
import HeaderLogin from '../../components/header/login/header';
import InputLogin from 'components/Login/input/input';
import { useLoginContext } from 'context/login-context';
import ButtonSubmit from 'components/ButtonSubmit/button-submit';
import logo from 'assets/img/logo-fundacred-branco.svg';
import * as S from './style';
import { EnumScreenName } from 'models/login';
import { verificaParametroDaUrl } from 'utils/verify-url-params';

function TelaDeLogin() {
  const {
    checkboxTerms,
    showTermsUse,
    setErrorMessage,
  } = useLoginContext();

  useEffect(() => {
    setErrorMessage && setErrorMessage('');
    
    const returnToParam = verificaParametroDaUrl('return_to');
    const loginZendeskParam = verificaParametroDaUrl('loginZendesk');

    if (
      loginZendeskParam &&
      !returnToParam?.match(/^https:\/\/atendimentofundacred\.zendesk\.com\/hc/)
    ) {
      window.location.href = `https://atendimentofundacred.zendesk.com/access/normal?${window.location.href.split('?')[1] || ''
        }`;
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Fundacred - Home</title>
      </Helmet>

      <CheckUpdates />

      <>
        <S.ContainerLeftStyled>
          <S.LogoStyled src={logo} />
          <LoginScreenCarousel />
        </S.ContainerLeftStyled>

        <S.ContainerRightStyled screen={EnumScreenName.TELA_LOGIN} showTermsUse={showTermsUse}>
          {showTermsUse ?
            <TermosDeUso />
            :
            <S.ContainerLoginStyled>

              <HeaderLogin />

              <S.FormGroupStyled>
                <S.H1Styled>Entrar no Portal</S.H1Styled>

                <InputLogin />

                <S.DivLogin isCheckbox={checkboxTerms?.showCheckbox}>
                  {checkboxTerms?.showCheckbox &&
                    <CheckboxLogin />
                  }

                  <ButtonSubmit />

                </S.DivLogin>

                <LgpdLogin />

              </S.FormGroupStyled>
            </S.ContainerLoginStyled>
          }
        </S.ContainerRightStyled>
      </>
    </>
  );
}

export default TelaDeLogin;
